export default __webpack_public_path__ + "static/en-8b6c02f580fba5ba82bb259376929969.png";